<template>
  <pt-adult-sell-order-detail class="pt-adult-sell-order-detail__page" :id="id" :value="value" ref="detail"></pt-adult-sell-order-detail>
</template>

<script>
import PtAdultSellOrderDetail from 'cps/adult-sell-order/pt-adult-sell-order-detail/withData'
export default {
  name: 'pt-adult-sell-order-detail__view',
  components: {
    'pt-adult-sell-order-detail': PtAdultSellOrderDetail
  },
  props: {
    // 路由参数 - 产品id
    id: {
      type: String,
      required: true
    },
    // 路由参数 - 产品数据，父组件可以直接传入整个产品对象绑定到详情页，也可以不传。
    value: {
      type: Object,
      default: null
    }
  }
}
</script>
